import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { OrgList, OrgListDefaultValues, OrgQueryDefaultValues } from 'src/app/components/organization/org-list';
import { OrganizationService } from 'src/app/services/organization.service';
import { ProvinceService } from 'src/app/services/province.service';

@Component({
    selector: 'app-org-list',
    templateUrl: './org-list.component.html',
    styleUrls: ['./org-list.component.scss'],
    standalone: false
})
export class OrgListComponent {
  orgList:OrgList[]=[];
  queryFilter = OrgQueryDefaultValues();
  provinces:any[]=[]
  totalRecords=0
  information=''
  columnsToDisplay = [
    'orgname','province', 'status',
  ]
  pageName = CheckPageAccess.ORGMANAGEMENT
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef


  constructor(private _orgservice:OrganizationService,private provinceservice:ProvinceService){}

  ngOnInit()
  {
    this.information = "<h4>Status Definitions</h4><br/><span>Active:</span> The organization is currently Active.<br/><br/>"+
    "<span>Inactive:</span> The organization is no longer active."
    this.provinceservice.getProvinces().subscribe({
      next:(data)=>
      {
        this.provinces=data;
      }
    })

    this.search();
   }

   handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex
    this.queryFilter.PageSize = e.pageSize
    this.searchWithFilters();
  }

  private searchWithFilters() {

    this._orgservice.getAllOrgs(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.orgList = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
		this.submitButton.nativeElement.click();
		event.preventDefault();
	  }
	}

  resetFilters() {
   this.queryFilter = OrgQueryDefaultValues();
   this.search();
    }

  search() {
    this.searchWithFilters();
    }
}
